import React__default from 'react';
import { Address } from './atoms/address-container.esm.js';
import { CompanyWebsite } from './atoms/company-website.esm.js';
import { ObfuscationSkeletonCompany } from './obfuscation-skeleton.esm.js';

/**
 * @description
 * **Component that defines a vertical arrangement of the company card data**
 *
 * @property {CompanyCardData} **data**: Data about the company
 * @property {showObfuscationSkeleton} **bool**: Show the obfuscation skeleton becuase user is not logged in
 */
var RightRailCompanyCard = function RightRailCompanyCard(_ref) {
  var data = _ref.data,
    showObfuscationSkeleton = _ref.showObfuscationSkeleton;
  if (!data) return null;
  var companyName = data.companyName,
    address = data.address,
    mainPhone = data.mainPhone,
    websiteUrl = data.websiteUrl,
    websiteLabel = data.websiteLabel;
  return /*#__PURE__*/React__default.createElement("section", {
    "automation-id": "right-rail-company-card",
    className: "border border-[#bfbfbf] p-6 font-sans text-p-16/5 font-normal shadow-[2px_6px_4px_0px_rgba(0,0,0,0.20)] lg:sticky lg:top-4 lg:max-w-[300px]"
  }, /*#__PURE__*/React__default.createElement("figure", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "overflow-hidden text-ellipsis text-p-18/[22.5px] font-bold"
  }, companyName), /*#__PURE__*/React__default.createElement(Address, {
    address: address
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "line-clamp-1",
    title: mainPhone
  }, mainPhone), websiteUrl && websiteLabel && /*#__PURE__*/React__default.createElement(CompanyWebsite, {
    websiteUrl: websiteUrl,
    websiteLabel: websiteLabel
  }), showObfuscationSkeleton && /*#__PURE__*/React__default.createElement(ObfuscationSkeletonCompany, null)));
};

export { RightRailCompanyCard };
//# sourceMappingURL=right-rail-company-card.esm.js.map
